export enum Features {
  mycompany_parking_stats = 'mycompany_parking_stats',
}
